module.exports={

    "title": "UB pickup repair prices",

    "ubprice": [

        {
            "model": "A34 5G",
            "rrp": 139,
            "ubrrp": 109
        },
        {
            "model": "A54 5G",
            "rrp": 139,
            "ubrrp": 109
        },

        {
            "model": "S20",
            "rrp": 239,
            "ubrrp": 179
        },
        {
            "model": "S20 5G",
            "rrp": 239,
            "ubrrp": 179
        },

        {
            "model": "S20+",
            "rrp": 259,
            "ubrrp": 194
        },
        {
            "model": "S20+ 5G",
            "rrp": 259,
            "ubrrp": 194
        },
        {
            "model": "S20 Ultra",
            "rrp": 279,
            "ubrrp": 209
        },
        {
            "model": "S21",
            "rrp": 219,
            "ubrrp": 154
        },
        {
            "model": "S21+",
            "rrp": 229,
            "ubrrp": 164
        },
        {
            "model": "S21 Ultra",
            "rrp": 274,
            "ubrrp": 194
        },
        {
            "model": "S22",
            "rrp": 189,
            "ubrrp": 139
        },
        {
            "model": "S22+",
            "rrp": 199,
            "ubrrp": 149
        },
        {
            "model": "S22 Ultra",
            "rrp": 259,
            "ubrrp": 194
        },
        {
            "model": "S23",
            "rrp": 209,
            "ubrrp": 164
        },
        {
            "model": "S23+",
            "rrp": 219,
            "ubrrp": 164
        },
        {
            "model": "S23 Ultra",
            "rrp": 289,
            "ubrrp": 224
        }

    ],

    "xxx": "copy end"

}